import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    Row,
    Col
    // Button
} from "antd";
import { KanBanParticipated } from "templates";

import { fetchStageCase } from "store/actions";
import { STATE_STATUS } from "constants";

import "styles/participated-view.css";

class ParticipatedView extends React.Component {
    render() {
        const {
            stagesStatus,
            stages,
            cases,
            caseCount,
            fetchStageCase,
            history,
            location
        } = this.props;
        let newStages = stages.filter(_ => {
            return caseCount.toJS()[_.stage_name] > 0;
        });
        return (
            <Row className={"px-5 h-100"}>
                <Col span={24} className={"h-100"}>
                    <KanBanParticipated
                        isDataFetched={stagesStatus === STATE_STATUS.FETCHED}
                        stages={newStages}
                        cases={cases}
                        caseCount={caseCount}
                        history={history}
                        location={location}
                        fetch={fetchStageCase.bind(null, "PARTICIPATED")}
                    />
                </Col>
            </Row>
        );
    }
}

ParticipatedView.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    stages: PropTypes.object,
    stagesStatus: PropTypes.string,
    cases: PropTypes.object,
    caseCount: PropTypes.object,
    fetchStageCase: PropTypes.func
};

const mapStateToProps = state => ({
    cases: state.cases.get("PARTICIPATED"),
    caseCount: state.caseCount.getIn(["PARTICIPATED", "data"]),
    stagesStatus: state.stages.get("status"),
    stages: state.stages.get("data")
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchStageCase
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ParticipatedView);
